<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>        
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">                   
                    <div class="col-md-6">
                        <div class="my-3 my-sm-0">
                            <img src="img/theme/book-1.png" class="img-fluid">
                        </div>
                    </div>
                    <div class="col-md-6 pb-5 text-center text-md-left">
                        
                         <div class="mb-5 text-center">
                            <img src="img/brand/white.png" style="width: 200px;" class="img-fluid">
                        </div>

                        <card type="secondary" shadow
                            header-classes="bg-white pb-5"
                            body-classes="px-lg-5 py-lg-5"
                            class="border-0 text-center">

                            <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
                            <span class="sr-only">Procesando...</span>

                            <div class="card-body">
                                <h3 class="card-title">
                                    Procesando
                                </h3>
                                <p class="card-text">
                                    Aguarda hasta que se complete la operación.
                                </p>
                            </div>
                        </card>                       
                    </div>
                </div>               
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
